var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-container"},[_c('div',{staticClass:"progress-bar",class:{ 'border-radius-right': _vm.percentage >= 95 },style:({ width: _vm.percentage + '%' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }